export default "__VITE_ASSET__CyUplzor__"